<template>
  <v-popover offset="5" :placement="placement">
      <label class="labelTitle">
        <span v-html="label"></span>
        <span class="ml-1" v-if="!hideIcon"><font-awesome-icon :icon="['fas', 'info-circle']" size="lg" /></span>
      </label>

      <template slot="popover">
        <div :style="{ width }">
          <div class="text-left"><slot /></div>
        </div>
      </template>
  </v-popover>
</template>

<script>
export default {
  name: 'BaseLabelWithPopover',
  props: {
    label: {
      type: String,
      required: false
    },
    placement: {
      type: String,
      default: 'right'
    },
    width: {
      type: String,
      default: '250px'
    },
    hideIcon: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  cursor: pointer;
}
</style>
